import { Input, InputProps } from '@chakra-ui/react';
import { FieldPath, UseFormReturn } from 'react-hook-form';

type MenuCategoryIdInputProps<TFieldValues> = InputProps & {
  name: FieldPath<TFieldValues>;
  register: UseFormReturn<TFieldValues>['register'];
};

export const MenuCategoryIdInput = <TFieldValues,>({
  name,
  register,
  ...inputProps
}: MenuCategoryIdInputProps<TFieldValues>) => (
  <Input
    type="text"
    {...register(name, {
      required: '必須項目です。',
      valueAsNumber: true,
      validate: {
        numberRegExp: (value) =>
          /^\d+$/.test(value as string) || '半角数字のみ入力できます。',
      },
    })}
    {...inputProps}
  />
);
